import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicButton } from 'core/components';

function FacilityOrderTemplateItemNewFlowDeleteModalTemplate({ facilityOrderTemplateItemNewFlowDeleteModalStore , t}) {
    const {
        item,
        deleteItem,
        modalParams
    } = facilityOrderTemplateItemNewFlowDeleteModalStore;

    return (
        <section>
            <div className="modal__header">
                <h3 className='modal__header__title'>Delete item?</h3>
            </div>
            <div className="modal__body">
                <div className='message message--sml message--primary type--wgt--bold'>{item.product.description}</div>
            </div>
            <div className='modal__footer is-right'>
                <BaasicButton
                    className='btn btn--med btn--light'
                    label={t('EDIT_FORM_LAYOUT.CANCEL')}
                    onClick={() => modalParams.close()}
                />
                <BaasicButton
                    className='btn btn--med btn--warning'
                    label={t('EDIT_FORM_LAYOUT.DELETE')}
                    onClick={() => deleteItem()}
                    focused={true}
                />
            </div>
        </section>
    )
}
 
FacilityOrderTemplateItemNewFlowDeleteModalTemplate.propTypes = {
    facilityOrderTemplateItemNewFlowDeleteModalStore: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(FacilityOrderTemplateItemNewFlowDeleteModalTemplate);
